import { useMutation } from 'react-query';
import BasicOrderInfoApi from '../BasicOrderInfoApi';

export function useMarkBookingRequestAsHandledMutation(orderId: number) {
    return useMutation<unknown, unknown, void>(() => BasicOrderInfoApi.markBookingRequestAsHandled(orderId));
}
